import HomeSearchForm from 'components/HomeSearchForm/HomeSearchForm'

export default HomeSearchForm
